import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

export const CheckoutErrorCellContainer = Box.withConfig({
  flexDirection: 'row',
});

export const Dot = Box.withConfig({
  marginX: 2,
  marginY: 2,
  height: 1,
  width: 1,
  backgroundColor: primitive.$bbqBrown,
  borderRadius: 'full',
});

export const ErrorText = withTypography({
  textAlign: 'center',
  variant: 'copyOne',
  lineHeight: 20,
  style: { marginBottom: 2 },
});
